/**
 * Module dependencies.
 */

import { useCryptoGestRates, useCryptoGestSettings } from 'app/hooks/requests/crypto-gest/use-crypto-gest';
import { formatMoney } from './format';

/**
 * `useDisplayMoney` — a currency-aware money formatter for Crypto Gest.
 *
 * Values are computed in USD across the backend; this converts them to the
 * user's chosen display currency (any world currency) via the live FX rate.
 */

export function useDisplayMoney() {
  const { data: settings } = useCryptoGestSettings();
  const { data: rates } = useCryptoGestRates();

  const currency = settings?.displayCurrency ?? 'EUR';
  const usdPerEur = rates?.usdPerEur ?? 1.08;

  // Units of the display currency per 1 USD. USD is 1; EUR falls back to the
  // Binance-derived rate; anything else comes from the world FX map.
  const perUsd =
    currency === 'USD' ? 1 : rates?.rates?.[currency] ?? (currency === 'EUR' && usdPerEur > 0 ? 1 / usdPerEur : 1);

  return {
    currency,
    usdPerEur,
    perUsd,
    format: (valueUsd: number | null | undefined) => formatMoney(valueUsd, currency, perUsd)
  };
}
